const TOKEN_KEY = "hos_access_token";
const BACKOFFICE_TOKEN_KEY = "hos_backoffice_access_token";
const POS_SESSION_TOKEN_KEY = "xybo_pos_staff_access_token";
const AUTH_CONTEXT_KEYS = [
  TOKEN_KEY,
  BACKOFFICE_TOKEN_KEY,
  POS_SESSION_TOKEN_KEY,
  "cybo_front_office_cashier_token",
  "hos_actor_type",
  "hos_partner_id",
  "hos_staff_member_id",
  "hos_user_role",
  "hos_user_email",
  "hos_profile_name",
  "_me",
];

function tokenRole(token: string | null): string {
  if (!token) return "";
  try {
    const body = token.split(".")[1];
    if (!body) return "";
    const normalized = body.replace(/-/g, "+").replace(/_/g, "/");
    const payload = JSON.parse(window.atob(normalized.padEnd(Math.ceil(normalized.length / 4) * 4, "="))) as { role?: unknown };
    return String(payload.role || "").trim().toLowerCase();
  } catch {
    return "";
  }
}

export function getAccessToken(): string | null {
  if (typeof window === "undefined") {
    return null;
  }
  const current = window.localStorage.getItem(TOKEN_KEY);
  if (tokenRole(current) === "pos_staff") {
    window.localStorage.setItem(POS_SESSION_TOKEN_KEY, current as string);
    const backoffice = window.localStorage.getItem(BACKOFFICE_TOKEN_KEY);
    return backoffice && tokenRole(backoffice) !== "pos_staff" ? backoffice : null;
  }
  if (current) {
    window.localStorage.setItem(BACKOFFICE_TOKEN_KEY, current);
    return current;
  }
  const backoffice = window.localStorage.getItem(BACKOFFICE_TOKEN_KEY);
  return backoffice && tokenRole(backoffice) !== "pos_staff" ? backoffice : null;
}

export function setAccessToken(token: string): void {
  if (typeof window === "undefined") {
    return;
  }
  if (tokenRole(token) === "pos_staff") {
    window.localStorage.setItem(POS_SESSION_TOKEN_KEY, token);
    if (window.localStorage.getItem(TOKEN_KEY) === token) window.localStorage.removeItem(TOKEN_KEY);
    return;
  }
  window.localStorage.setItem(TOKEN_KEY, token);
  window.localStorage.setItem(BACKOFFICE_TOKEN_KEY, token);
}

export function clearAccessToken(): void {
  if (typeof window === "undefined") {
    return;
  }
  for (const key of AUTH_CONTEXT_KEYS) {
    window.localStorage.removeItem(key);
    window.sessionStorage.removeItem(key);
  }
}

export function clearAuthSession(): void {
  clearAccessToken();
}

export function getAuthHeaders(base?: HeadersInit): Headers {
  const headers = new Headers(base);
  const token = getAccessToken();

  if (token && !headers.has("Authorization")) {
    headers.set("Authorization", `Bearer ${token}`);
  }

  return headers;
}
